<template>
  <VueSelectInput
    v-model="context.model"
    :options="options"
    v-bind="context.attributes"
    :reduce="x => x.value"
    autocomplete="disabled"
    :multiple="multiple"
    @option:selecting="selecting"
    @option:selected="selected"
  >
    <template #option="{ label, subtitle, prefix, suffix, component }">
      <template v-if="!component">
        <PrefixSuffixSlot :prefix="prefix" :suffix="suffix">
          <p class="vs__label">{{ label }}</p>
        </PrefixSuffixSlot>

        <p v-if="!!subtitle" class="vs__subtitle">{{ subtitle }}</p>
      </template>

      <template v-else>
        <component :is="component.name" v-bind="component.props" v-on="component.events">
          <template v-for="(slot, name) in component.slots" #[name]>
            <div v-bind:key="name" v-html="slot"></div>
          </template>
        </component>
      </template>
    </template>

    <template #selected-option="{ label, prefix, suffix }">
      <PrefixSuffixSlot :prefix="prefix" :suffix="suffix">
        <p class="vs__label">{{ label }}</p>
      </PrefixSuffixSlot>
    </template>

    <div slot="no-options">No hay opciones disponibles.</div>
  </VueSelectInput>
</template>

<script>
import PrefixSuffixSlot from '@/lego/components/appends/PrefixSuffixSlot.vue';

export default {
  components: {
    VueSelectInput: () => import('vue-select'),
    PrefixSuffixSlot,
  },
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
  computed: {
    options() {
      return this.context.options;
    },
    multiple() {
      return this.context.attributes.multiple ?? false;
    },
  },
  methods: {
    selecting(e) {
      this.$emit('option:selecting', e);
    },
    selected(e) {
      this.$emit('option:selected', e);
    },
  },
};
</script>

<style lang="postcss">
@import 'vue-select/dist/vue-select.css';
</style>

<style lang="postcss" scoped>
/deep/ .vs {
  &__dropdown {
    &-toggle {
      @apply w-full !rounded-md border-hairline bg-neutral-white border-neutral-semilight px-nano py-micro;

      .form &,
      .input-select--light& {
        @apply bg-neutral-white border-neutral-semilight;
      }
      .formulate-input[data-is-showing-errors='true']& {
        @apply rounded-md border-feedback-error-medium border-hairline;
      }
      .patch_form & {
        @apply bg-neutral-lightest;
      }
      .fotocasa & {
        @apply rounded-s py-nano;
      }

      .vs__search {
        @apply style-body-sm text-neutral-semidark !outline-none px-nano py-0 border-none w-0 rounded-none;
      }
      svg {
        @apply fill-support-dark;

        .fotocasa & {
          @apply fill-neutral-semidark;
        }
      }
    }
    &-menu {
      @apply p-0 border-solid rounded-md border-hairline border-neutral-semilight;
    }
    &-option {
      @apply px-xxs py-micro text-neutral-darkest;

      &--highlight {
        @apply bg-support-lightest text-neutral-darkest;
      }

      .fotocasa & {
        @apply py-nano px-xxxs;
      }
    }
  }
  &__no-options {
    @apply px-xxs py-micro style-body-sm text-neutral-darkest;
  }
  &__search {
    @apply z-0 m-0 focus:m-0;
  }
  &__actions {
    @apply py-0;
  }
  &__selected {
    @apply mt-0 style-body-sm text-neutral-darkest w-full;

    &-options {
      @apply flex-nowrap;
    }
  }
  &__label {
    @apply style-body-sm text-neutral-darkest m-0;

    .fotocasa & {
      @apply style-overline;
    }
  }
  &__subtitle {
    @apply style-overline mt-quark text-neutral-semidark;
  }
}
/deep/ .slot {
  &__wrapper {
    @apply justify-between gap-nano;
  }
}
</style>
